import DeviceManager from '../utils/device-manager';

export function initReadMore() : void {
    document.querySelectorAll<HTMLElement>('.read-more-toggler').forEach($toggler => {
        new ReadMore($toggler);
    });
}

class ReadMore {
    ID: string; // Read more ID
    initialized: boolean = false;
    $toggler: HTMLElement;
    $content: HTMLElement;
    moreLabel: string|null;
    lessLabel: string|null;

    constructor($toggler: HTMLElement) {
        this.$toggler = $toggler;
        this.ID = this.$toggler.getAttribute('read-more-id-content') as string;
        this.$content = document.querySelector(`#${this.ID}.read-more-content`) as HTMLElement;
        this.moreLabel = this.$toggler.getAttribute('read-more-label');
        this.lessLabel = this.$toggler.getAttribute('read-less-label');

        if (this.$content) {
            this.$toggler.addEventListener('click', e => {
                e.preventDefault();
    
                if (this.$content.classList.contains('close')) {
                    this.$content.classList.remove('close');

                    if (this.lessLabel) {
                        this.$toggler.innerHTML = this.lessLabel;
                    }
                } else {
                    this.$content.classList.add('close');

                    if (this.moreLabel) {
                        this.$toggler.innerHTML = this.moreLabel;
                    }
                }
            });

            DeviceManager.addWindowCallback(this.initialize.bind(this));
        }
    }

    initialize() : void {
        const contentClosed = this.$content.classList.contains('close');

        // Reset max-height
        this.$content.style.maxHeight = !contentClosed ? '50000px' : '';

        // Disable transition
        this.$content.style.transition = 'none';

        // Open content
        this.$content.classList.remove('close');

        // Get height of content
        const height = this.$content.clientHeight;

        // Enable transition
        this.$content.style.transition = '';

        if (contentClosed) {
            // Close the content
            this.$content.classList.add('close');
        }

        // Set the new max-height
        this.$content.style.maxHeight = height + 'px';
    }
}
